<template>
  <Loading v-if="loading" />
  <div
    v-if="!status?.message && loading && !authenticationSignicat"
    class="pleaseWait"
  >
    <p>{{ $t('pleaseWait') }}</p>
  </div>
  <div
    v-if="status?.message && !loading && !authenticationSignicat"
    class="signicatVerify__error"
  >
    <div class="error" role="alert">
      {{ $t(status.message) }}
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'SignicatVerify',
  components: {
    Loading
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('account', ['authenticationSignicat', 'status'])
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('account', ['getAuthenticationSignicat']),
    async show() {
      this.loading = true;
      const { businessId, deliveryId } = this.$route.params;

      await this.getAuthenticationSignicat({ businessId, deliveryId });

      if (this.authenticationSignicat?.authLink) {
        const a = document.createElement('a');
        a.href = this.authenticationSignicat.authLink;
        a.click();
        a.remove();
      }

      this.loading = false;
    }
  }
})
export default class SignicatVerifyComponent extends Vue {}
</script>

<style lang="scss" scoped>
.pleaseWait {
  p {
    position: absolute;
    top: 43%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'Ubuntu-Medium';
    font-size: $eighteenSize;
    line-height: $twentyOneSize;
    font-weight: 400;
  }
}

.signicatVerify__error {
  .error {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: $sixteenSize;
    line-height: $eighteenSize;
    font-weight: 400;
    color: $messageError;
  }
}
</style>
